var exports = {
  "kL": "xf0b3b88a--bc0e76--container",
  "nf": "xf0b3b88a--bc0e76--link",
  "Kk": "xf0b3b88a--bc0e76--icon",
};

module.exports = exports;
